<template>
  <qx-card title="列表">
    <qx-img-dialog ref="imgDialog" />
    <ApproveDialog ref="approveDialog" @sub="getData" />
    <span slot="titleLeft">
      【已核销总金额：
      <span class="primary">
        {{
          tableData.originData.verificatMoney
            ? tableData.originData.verificatMoney / 100
            : 0
        }} </span
      >】 【未核销总金额：
      <span class="primary">
        {{
          tableData.originData.noVerificatMoney
            ? tableData.originData.noVerificatMoney / 100
            : 0
        }} </span
      >】
    </span>
    <LogRightDialog ref="logRightDialog" busiCode="230003" />
    <section slot="titleRight">
      <qx-permpisions permpisions="2000409">
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ac;</i>批量付款
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions permpisions>
              <el-dropdown-item @click.native="toPay(tableData.selectResult)">给一个人付款</el-dropdown-item>
            </qx-permpisions>
            <qx-permpisions permpisions>
              <el-dropdown-item @click.native="toPay(tableData.selectResult, 'quick')">给多个人付款</el-dropdown-item>
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>

      <qx-permpisions permpisions="2000411">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="manualPaymentBO.ajax?cmd=queryPayoutIntfs"
          :params="fullSearchData"
          bizName="公司平台支付数据导出"
          bizCode="exp100070"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'userName'">
                  <span
                    class="primary cur"
                    v-if="
                      scope.row.virtualState !== 1 && !scope.row.mustAutomatic
                    "
                    @click="toUserNameView(scope.row)"
                    >{{ scope.row[scope.column.property] }}</span
                  >
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </section>
                <!-- 业务单号 -->
                <section
                  v-else-if="scope.column.property === 'busiCode'"
                  @click="toBusiCodeDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 业务单号 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1004020102',
                    // showCondition:scope.row.hasPermission && !scope.row.isFinallyNode,
                    showCondition:!scope.row.isFinallyNode,
                    name: '审核',
                    event: () => showApproveDialog(scope.row),
                  },
                  {
                    // 暂时屏蔽支付相关的操作
                     permpisions: '1004020101',
                    // showCondition: scope.row.hasPermission && scope.row.isFinallyNode,
                    showCondition: scope.row.isFinallyNode,
                    name: '付款',
                    event: () => toPay([scope.row]),
                  },
                  {
                    permpisions: '2000413',
                    showCondition: scope.row.fileId,
                    name: '付款截图',
                    event: () => showPayImg(scope.row),
                  },
                  {
                    permpisions: '2000424',
                    showCondition:
                      scope.row.isAutoMatic === 1 &&
                      scope.row.isTurnAutomatic !== 2 &&
                      scope.row.respCode !== 6 &&
                      !scope.row.mustAutomatic,
                    name: '停止自动',
                    event: () => stopAuto(scope.row),
                  },
                  {
                    permpisions: '2000428',
                    showCondition:
                      scope.row.isAutoMatic === 1 && scope.row.respCode === 6,
                    name: '撤回',
                    event: () => back(scope.row),
                  },
                  {
                   permpisions: '2000412',
                   showCondition: true,
                   name: '日志',
                   event: () => showLog(scope.row.flowId),
                  },
                ]"
              />
<!--              <section>-->
<!--                <qx-permpisions-->
<!--                  permpisions="1004020102"-->
<!--                  v-if="scope.row.hasPermission && !scope.row.isFinallyNode"-->
<!--                >-->
<!--                  <span class="primary cur" @click="showApproveDialog(scope.row)">审核</span>-->
<!--                </qx-permpisions>-->
<!--                <qx-permpisions-->
<!--                  permpisions="1004020101"-->
<!--                  v-if="scope.row.hasPermission && scope.row.isFinallyNode"-->
<!--                >-->
<!--                  <span class="primary cur" @click="toPay([scope.row])">付款</span>-->
<!--                </qx-permpisions>-->
<!--                <qx-permpisions permpisions="2000413" v-if="scope.row.fileId">-->
<!--                  <span class="primary cur" @click="showPayImg(scope.row)">付款截图</span>-->
<!--                </qx-permpisions>-->
<!--                <qx-permpisions-->
<!--                  permpisions="2000424"-->
<!--                  v-if="-->
<!--                    scope.row.isAutoMatic === 1 &&-->
<!--                    scope.row.isTurnAutomatic !== 2 &&-->
<!--                    scope.row.respCode !== 6 &&-->
<!--                    !scope.row.mustAutomatic-->
<!--                  "-->
<!--                >-->
<!--                  <span class="primary cur" @click="stopAuto(scope.row)">停止自动</span>-->
<!--                </qx-permpisions>-->
<!--                <qx-permpisions-->
<!--                  permpisions="2000428"-->
<!--                  v-if="scope.row.isAutoMatic === 1 && scope.row.respCode === 6"-->
<!--                >-->
<!--                  <span class="primary cur" @click="back(scope.row)">撤回</span>-->
<!--                </qx-permpisions>-->
<!--                <qx-permpisions permpisions="2000412">-->
<!--                  <span class="primary cur" @click="showLog(scope.row.flowId)">日志</span>-->
<!--                </qx-permpisions>-->
<!--              </section>-->
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import ApproveDialog from './approveDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  companyPayList,
  companyPayStopAuto,
  companyPayBack,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    ApproveDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        originData: {},
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'flowId',
        title: [ // 表头
          { prop: 'busiCode', label: '业务单号', fixed: true },
          { prop: 'flowId', label: '流水号码' },
          { prop: 'createDate', label: '应付时间' },
          { prop: 'userName', label: '业务方' },
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'busiIdName', label: '业务类型' },
          { prop: 'dependTime', label: '要求发车时间' },
          { prop: 'customName', label: '客户名称' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'collectionUserName', label: '代收名称' },
          { prop: 'orderRemark', label: '订单备注' },
          { prop: 'isNeedBillName', label: '票据类型' },
          { prop: 'billLookUp', label: '收票主体' },
          { prop: 'txnAmtDouble', label: '支付金额' },
          { prop: 'payConfirmName', label: '打款状态' },
          { prop: 'updateDate', label: '核销时间' },
          { prop: 'bankTypeName', label: '付款方式' },
          { prop: 'accName', label: '收款账户名' },
          { prop: 'accNo', label: '收款帐号' },
          { prop: 'remark', label: '备注' },
          { prop: 'auditRemark', label: '审核备注' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: companyPayList,
    // 前往付款页面
    toBatchPayEdit (item, index) {
      console.log(item, index);
    },
    showApproveDialog (item) { // 审核
      this.$refs.approveDialog.show(item);
    },
    showPayImg (item) { // 付款截图
      this.$refs.imgDialog.show(item.fileUrl);
    },
    async stopAuto (item) { // 停止自动
      const confirmRes = await this.$confirm('温馨提示：为避免重复打款，停止自动打款前系统需要与银行确认是否已经打款，请等待几分钟再操作付款！', '停止自动打款确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await companyPayStopAuto({
          flowId: item.flowId,
          isNeedBill: item.isNeedBill,
        });
        if (!res.failed) {
          this.$message.success('提交停止申请成功');
          this.getData();
        }
      }
    },
    async back (item) { // 撤回
      const confirmRes = await this.$confirm('是否确认撤回此条付款记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await companyPayBack({
          flowId: item.flowId,
        });
        if (!res.failed) {
          this.$message.success('撤回成功');
          this.getData();
        }
      }
    },
    toUserNameView (item) { // 用户名
      switch (item.userType) {
        case 6:
          this.jump({
            label: '车队详情',
            url: `/manage/other/fleet?id=${item.tenantId}`,
            full: true,
          });
          break;
        case 3:
          this.jump({
            label: '司机详情',
            url: `/manage/archives/driver/archives/detail?id=${item.userId}`,
            full: true,
          });
          break;
        case 1:
          this.jump({
            label: '查看员工',
            url: `/manage/system/jurisdiction/worker/detail?id=${item.userId}`,
            full: true,
          });
          break;
        case 2:
        case 4:
          this.jump({
            label: '服务商详情',
            url: `/manage/service/merchant/manage/detail?id=${item.userId}`,
            full: true,
          });
          break;
        default:
          break;
      }
    },
    toBusiCodeDetail (item) {
      switch (item.subjectsId) {
        // case 2302: // ETC
        //   break;
        case 1443: // 司机报销
        case 1445: // 车管报销
        case 1800: // 服务费
        case 50070: // 违章
        case 1674: // 北斗缴费
        case 1131: // 油费充值（流水）
        case 4020: // 轮胎租赁
          break;
        case 1653: // 邮费
        case 1657: // 维修
          this.jump({
            label: '交易记录',
            url: `/manage/service/site/transRecord?orderId=${item.busiCode}`,
            full: true,
          });
          break;
        case 1626: // 开票申请
        case 1640:
          this.jump({
            label: '申请记录',
            url: '/manage/operate/invoice/record',
            full: true,
          });
          break;
        case 1732: // 供应商油卡充值
          this.jump({
            label: '交易记录',
            url: `/manage/cost/car/apply?applyCode=${item.busiCode}`,
          });
          break;
        // case 1851: // 新车购置
        //   break;
        case 1441:
          this.jump({
            label: '车管借支详情',
            url: `/manage/cost/borrow/driver/detail?id=${item.busiCode}&detailType=busiCode`,
            full: true,
          });
          break;
        case 1431: // 司机借支
          this.jump({
            label: '司机借支详情',
            url: `/manage/cost/borrow/driver/detail?id=${item.busiCode}&detailType=busiCode`,
            full: true,
          });
          break;
        case 1816: // 管理费申请
          this.jump({
            label: '管理费用详情',
            url: `/manage/cost/manage?busiCode=${item.busiCode}`,
            full: true,
          });
          break;
        case 1728: // 车辆费用申请
        case 1832:
          this.jump({
            label: '车辆费用详情',
            url: `/manage/cost/car/car?busiCode=${item.busiCode}`,
            full: true,
          });
          break;
        case 1630: // 供应商油卡充值
          this.jump({
            label: '油卡充值核销',
            url: `/manage/service/oil/recharge?busiCode=${item.busiCode}`,
          });
          break;
        case 4013: // 维保管理
          this.jump({
            label: '维保申请详情',
            url: `/manage/cost/car/apply/maintenanceDetail?id=${item.busiCode}`,
            full: true,
          });
          break;
        default: // 订单详情 1530 || 1651 || 1532 || 1536 || 1614 || 1577
          // 1611 || 1655 || 1632 || 1639 || 1644 || 1643 || 1647 || 1662 || 1561 || 1563
          this.jump({
            label: `订单详情-${item.busiCode}`,
            url: `/manage/operate/order/deal/orderDetailTab?id=${item.busiCode}`,
            full: true,
          });
          break;
      }
    },
    toPay (arr, type) {
      if (arr.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const ids = arr.map((item) => item.flowId);
      const result = [];
      this.tableData.data.forEach((item) => {
        if (ids.indexOf(item.flowId) !== -1) {
          result.push(item);
        }
      });
      let userId = '';
      let userType = '';
      let isNeedBill = '';
      let txnAmt = 0;
      for (let i = 0; i < result.length; i++) {
        if (result[i].payConfirm !== 0) {
          this.$message.warning('选中数据中有非未打款数据');
          return;
        }
        if (type !== 'quick') {
          if (!userId) {
            userId = result[i].userId;
          } else if (userId !== result[i].userId) {
            this.$message.warning('选中数据中收款人不一致');
            return;
          }
          if (!userType) {
            userType = result[i].userType;
          } else if (userType !== result[i].userType) {
            this.$message.warning('选中数据中收款人不一致');
            return;
          }
          if (!isNeedBill) {
            isNeedBill = result[i].isNeedBill;
          } else if (isNeedBill !== result[i].isNeedBill) {
            this.$message.warning('选中数据中票据类型不一致');
            return;
          }
        }
        txnAmt += result[i].txnAmtDouble;
      }
      let label = '';
      if (type) {
        label = '一键支付';
      } else if (ids.length === 1) {
        label = '付款';
      } else {
        label = '批量付款';
      }
      this.jump({
        label,
        url: `/manage/getPay/writeOff/companyPay/pay?ids=${ids.join(',')}&txnAmt=${txnAmt}&isNeedBill=${isNeedBill}&userId=${userId}&userType=${userType}&type=${type || ''}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
